var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9214 15.6945H3.07831C2.29984 15.6945 1.6665 15.0719 1.6665 14.3059V5.97261C1.6665 5.20664 2.29984 4.58337 3.07831 4.58337H16.9214C17.6998 4.58337 18.3332 5.20664 18.3332 5.97261V14.3059C18.3332 15.0719 17.6998 15.6945 16.9214 15.6945ZM2.36095 14.3059C2.36095 14.6889 2.68282 15 3.07831 15H16.9214C17.3169 15 17.6387 14.6889 17.6387 14.3059V5.97261C17.6387 5.91462 17.6294 5.85907 17.6155 5.80525L10.2259 12.1389C10.1606 12.1948 10.0804 12.2226 9.99984 12.2226C9.91928 12.2226 9.83907 12.1948 9.7738 12.1389L2.38421 5.80525C2.37032 5.85907 2.36095 5.91462 2.36095 5.97261V14.3059ZM3.07831 5.27817C3.00678 5.27817 2.93907 5.29136 2.8738 5.31046L9.99984 11.4181L17.1259 5.31046C17.0606 5.29136 16.9929 5.27817 16.9214 5.27817H3.07831Z",
    stroke: "#181C32",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.74e38b9100566e32f92cee9d3995c8b7.svg";
export { ForwardRef as ReactComponent };